var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "10.583mm",
    height: "10.583mm",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "BG"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_11",
    "data-name": "Ebene_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0,7.5h30v15H0V7.5Z",
    style: {
      fill: "#fcd116"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,15h30v7.5H0v-7.5Z",
    style: {
      fill: "#009e49"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,7.5h10v15H0V7.5Z",
    style: {
      fill: "#ce1126"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M5,12.5l-.773,2.378,1.189.386",
    style: {
      fill: "#000000"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "a1",
    "data-name": "a",
    d: "M5,12.5l.773,2.378-1.189.386"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "a2",
    "data-name": "a",
    d: "M7.378,14.227h-2.5v1.25"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "a3",
    "data-name": "a",
    d: "M7.378,14.227l-2.023,1.469-.735-1.011"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "a4",
    "data-name": "a",
    d: "M6.469,17.023l-.773-2.378-1.189.386"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "a5",
    "data-name": "a",
    d: "M6.469,17.023l-2.023-1.469.735-1.011"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "a6",
    "data-name": "a",
    d: "M3.531,17.023l2.023-1.469-.735-1.011"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "a7",
    "data-name": "a",
    d: "M3.531,17.023l.773-2.378,1.189.386"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "a8",
    "data-name": "a",
    d: "M2.622,14.227l2.023,1.469.735-1.011"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "a9",
    "data-name": "a",
    d: "M2.622,14.227h2.5v1.25"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGw);
export default __webpack_public_path__ + "static/media/GW.d807fa2455be77ea6cfacfcc65a5f372.svg";
export { ForwardRef as ReactComponent };